/** 
    This is business rule that we need to accept
    0 resolves as not set => null
    undefined resolves as not set => null
    null resolves as not set => null
    Any number resolves as expected
 */
export const resolveContractMinutes = (
  contractHours: number | string | undefined
): number | null => {
  if (!contractHours || Number(contractHours) === 0) {
    return null;
  }
  return Number(contractHours) * 60;
};
